<template>
    <div>
        <w-alert
          v-if="alert"
          :message="alert.message"
          :level="alert.level"
        />
        <div v-if="group" data-test-id="group">
            <section>
                <h2 class="section-title">
                    {{ l.t("app.contact-group-info", "Contact group info") }}
                </h2>
                <w-form @submit="submitted" @changed="may_submit = true">
                    <FormInput :label="l.t('app.name', 'Name')">
                        <w-text-field v-model="group.name" :rules="[$validation.required()]" hide-details='auto' data-test-id="group-name-input"/>
                    </FormInput>
                    <FormInput>
                        <w-btn :disabled="!may_submit" type="submit" color="primary" data-test-id="group-submit-btn">{{ l.t("app.save", "Save") }}</w-btn>
                    </FormInput>
                </w-form>
            </section>
        </div>
    </div>
</template>
<script>
  import l from '../../libs/lang';
  import FormInput from '../elements/form/FormInput.vue';

  export default {
    props: ['_group'],
    components: {
      FormInput,
    },
    data() {
      return {
        l,
        loading: false,
        alert: null,
        group: null,
        may_submit: false,
      };
    },
    created() {
      this.$data.group = this.$props._group;
    },
    methods: {
      submitted(e) {
        if (e) e.preventDefault();
        this.$emit('submitted', this.$props._group);
      },
    },
  };
</script>
